<scitis-app-global-page-header [pageTitle]="'Logs'">
</scitis-app-global-page-header>

<div class="card mb-3">
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-hover vertical-align-middle mb-0">
        <thead>
          <tr>
            <th style="width: 65%;" (sort)="onColumnSort($event)" class="sortable" sortable="link">
              <span translate>Name</span></th>
              <th style="width: 15%;" (sort)="onColumnSort($event)" class="sortable" sortable="size">
                <span translate>Size</span>
              </th>
              <th style="width: 20%;" (sort)="onColumnSort($event)" class="sortable" sortable="modifiedDate">
                <span translate>Modified</span>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (log of logs; track log) {
              <tr>
                <td>
                  <a [href]="log.link" [title]="('Download' |translate)+' '+ log.name">
                    <i class="fa-solid fa-download mr-2"></i> <span [innerText]="log.name"></span>
                  </a>
                </td>
                <td [innerText]="log.size | filesize"></td>
                <td [innerText]="log.modifiedDate | date:'medium'"></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
